<template>
  <div class="container">
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">新闻资讯详情</a></p>
      </div>
    </div> -->
    <!--新闻内页-->
    <div class="neiy">
      <div class="commen1">
        <div class="xwnz fl">
          <div class="xwnza">
            <h1>{{ datalist.title }}</h1>
            <p>发布时间：{{ datalist.date }}<span>|</span>发布者：印工社</p>
          </div>
          <div class="xwnzb" v-html="datalist.content">
            {{ datalist.content }}
          </div>
          <div class="fhlbx">
            <a href="javascript:void(0);" @click="back">返回列表</a>
          </div>
        </div>
        <div class="xwny fr pc">
          <div class="xwnya">
            <h6>最新资讯</h6>
            <img src="@/view/images/y75.png" />
          </div>
          <div class="xwnyb" v-for="item in News" :key="item.id">
<!--            <div>{{item.content}}</div>-->
            <div @click="ToDetail(item)">
              <div class="xwnyb_t"><img :src="item.cover" /></div>
              <div class="xwnyb_w">
                <h6>{{ item.title }}</h6>
                <p>{{ item.createTime }}</p>
                <img src="@/view/images/y21.png" />
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
          <!-- <div class="xwnyb">
            <a href="#">
              <div class="xwnyb_t"><img src="@/view/images/y70.jpg" /></div>
              <div class="xwnyb_w">
                <h6>如何定义印刷智能化，值得思考</h6>
                <p>2021-05-24</p>
                <img src="@/view/images/y21.png" />
                <div class="clearfix"></div>
              </div>
            </a>
          </div>
          <div class="xwnyb">
            <a href="#">
              <div class="xwnyb_t"><img src="@/view/images/y69.jpg" /></div>
              <div class="xwnyb_w">
                <h6>如何定义印刷智能化，值得思考</h6>
                <p>2021-05-24</p>
                <img src="@/view/images/y21.png" />
                <div class="clearfix"></div>
              </div>
            </a>
          </div>
          <div class="xwnyb">
            <a href="#">
              <div class="xwnyb_t"><img src="@/view/images/y71.jpg" /></div>
              <div class="xwnyb_w">
                <h6>如何定义印刷智能化，值得思考</h6>
                <p>2021-05-24</p>
                <img src="@/view/images/y21.png" />
                <div class="clearfix"></div>
              </div>
            </a>
          </div>
          <div class="xwnyb">
            <a href="#">
              <div class="xwnyb_t"><img src="@/view/images/y69.jpg" /></div>
              <div class="xwnyb_w">
                <h6>如何定义印刷智能化，值得思考</h6>
                <p>2021-05-24</p>
                <img src="@/view/images/y21.png" />
                <div class="clearfix"></div>
              </div>
            </a>
          </div> -->
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <!--留言-->
    <!-- <div class="lyan reveal-dettop">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'informDet',
  components: {
    CounSel,
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      id: '',
      datalist: '',
      count: 5,
      page: 0,
      News: [],
    };
  },
  methods: {
    // 跳转到详情页面
    ToDetail(item) {
      if(item.address) {
        window.open(item.address, '_blank')
      } else {
        this.$router.push(`/informdet?id=${item.id}`);
        this.init();
      }

    },
    // 侧边最新资讯
    getNews() {
      this.$axios({
        method: 'get',
        url:
          `${process.env.API_HOST
          }/portal/new?count=${this.count}&page=${this.page}`,
      })
        .then((res) => {
          if (res.data.code === '200') {
            this.News = res.data.message.data.list;
          }
        })
        .catch((mgs) => {
          console.log(mgs);
        });
    },
    init() {
      this.id = this.$route.query.id;
      this.newlistdet();
    },
    back() {
      this.$router.push({ path: '/information'}); // 返回上一层
    },
    newlistdet() {
      const _this = this;
      const { id } = _this;
      const url = `${process.env.API_HOST}/portal/new/detail?id=${id}`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'get',
        url,
        data: {},
      }).then((res) => {

        const json = res.data;
        if (json.code == 200) {
          console.log(json)
          const { data } = json.message;
          _this.datalist = data;
        }
      });
    },
  },
  mounted() {},
  created() {
    this.init();
    this.getNews();
  },
};
</script>

<style lang='scss'>
.xwnzb{
  p {
    overflow-wrap: break-word;
  }
  a {
    text-decoration: underline;
    color: #551A8b;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/informdet.vue